import { FC, useState } from 'react';
import { BsChevronLeft, BsExclamationTriangle, BsHourglassSplit } from 'react-icons/bs';
import { SiPayModal } from 'utilities/components';
import { Button } from '../button/button.index';
import {
    PAYA_CYCLES,
    PAYA_CYCLES_DESCRIPTIONS,
    PAYA_CYCLES_NOTE,
    PAYA_CYCLES_TITLE,
} from './payaCyclesModal.data';

interface Props {
    isOpen: boolean;
    onClose: () => void;
}

export const PayaCyclesModal: FC<Props> = ({ isOpen, onClose }) => {
    return (
        <SiPayModal isOpen={isOpen} onClose={onClose} maxWidth={520}>
            <div className={'w-full flex flex-col'}>
                <div className={'flex items-center gap-3'}>
                    <div className={'w-10 h-10 rounded-full bg-badge-infoBg flex items-center justify-center shrink-0'}>
                        <BsHourglassSplit size={18} className={'text-primary-100'} />
                    </div>
                    <span className={'font-bold text-base text-black-100 max-lg:text-sm'}>{PAYA_CYCLES_TITLE}</span>
                </div>

                <div className={'flex flex-col gap-3 mt-5'}>
                    {PAYA_CYCLES_DESCRIPTIONS.map((description, index) => (
                        <p key={index} className={'font-medium text-sm text-black-80 leading-7 max-lg:text-xs'}>
                            {description}
                        </p>
                    ))}
                </div>

                <div className={'mt-4 rounded-2xl border border-primary-20 overflow-hidden'}>
                    <div className={'grid grid-cols-2 bg-background'}>
                        <span className={'font-bold text-sm text-black-100 text-center py-3 max-lg:text-xs'}>
                            زمان درخواست برداشت
                        </span>
                        <span className={'font-bold text-sm text-black-100 text-center py-3 max-lg:text-xs'}>
                            زمان تقریبی واریز به حساب
                        </span>
                    </div>
                    {PAYA_CYCLES.map((cycle, index) => (
                        <div
                            key={index}
                            className={`grid grid-cols-2 items-center ${index !== 0 ? 'border-t border-t-background' : ''}`}
                        >
                            <span className={'font-medium text-sm text-black-100 text-center py-3 max-lg:text-xs'}>
                                {cycle.requestTime}
                            </span>
                            <span className={'font-bold text-sm text-primary-100 text-center py-3 max-lg:text-xs'}>
                                {cycle.depositTime}
                                {cycle.hint && (
                                    <span className={'block font-medium text-xs text-black-60 mt-1'}>{cycle.hint}</span>
                                )}
                            </span>
                        </div>
                    ))}
                </div>

                <div
                    className={
                        'flex items-start gap-2 mt-4 p-3 rounded-lg bg-badge-warningBg border border-warning-default'
                    }
                >
                    <BsExclamationTriangle size={16} className={'text-warning-default shrink-0 mt-1'} />
                    <p className={'font-medium text-xs text-black-100 leading-6'}>
                        <span className={'font-bold'}>توجه: </span>
                        {PAYA_CYCLES_NOTE}
                    </p>
                </div>

                <Button type={'primary'} className={'w-full mt-6'} onClick={onClose}>
                    متوجه شدم
                </Button>
            </div>
        </SiPayModal>
    );
};

interface ButtonProps {
    className?: string;
}

export const PayaCyclesButton: FC<ButtonProps> = ({ className }) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);

    return (
        <>
            <PayaCyclesModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
            <div
                className={`flex items-center gap-3 rounded-2xl bg-background px-4 py-3 clickable ${className ?? ''}`}
                onClick={() => setIsOpen(true)}
            >
                <BsHourglassSplit size={18} className={'text-primary-100 shrink-0'} />
                <div className={'w-px self-stretch bg-primary-20'} />
                <span className={'flex-1 font-medium text-sm text-black-100 max-lg:text-xs'}>{PAYA_CYCLES_TITLE}</span>
                <BsChevronLeft size={14} className={'text-black-60 shrink-0'} />
            </div>
        </>
    );
};
